import React from "react";
import Typography from "@mui/material/Typography";

export default function PrescriptionSymbol({ size = 48 }) {
  return (
    <Typography
      component="div"
      sx={{
        fontSize: `${size}px`,   // configurable pixel size
        fontWeight: "bold",
        fontStyle: "italic"
      }}
    >
      ℞
    </Typography>
  );
}
